export function filterMenuByPermissions(nodes = [], can) {
    return nodes
        .map(node => {
            if (!node) return null;

            // Always keep visual-only menu nodes
            if (node.type === 'divider') {
                return node;
            }

            const hasPermission =
                !node.requiredPermission || can(node.requiredPermission);

            if (!hasPermission) {
                return null;
            }

            if (!node.children) {
                return node;
            }

            const filteredChildren = filterMenuByPermissions(node.children, can);

            if (
                (node.type === 'group' || node.type === 'collapse') &&
                filteredChildren.length === 0
            ) {
                return null;
            }

            return {
                ...node,
                children: filteredChildren
            };
        })
        .filter(Boolean);
}
